// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'

import RecordSection from 'syft-acp-core/components/RecordSection'
import config from 'syft-acp-core/config'

type ComplianceLinksSectionProps = {
  complianceLink?: string
  workerId: number
  countryCode: string
}

const getComplianceWebappBaseUrl = (): string =>
  config.isDeployEnvTestOrDev()
    ? 'https://worker-compliance-webapp.sandbox.qa.indeed.net'
    : 'https://compliance.indeed.com'

const containerStyle = { padding: '8px 20px' } as const
const linkStyle = { marginBottom: '8px' } as const

const ComplianceLinksSection = ({ complianceLink, workerId, countryCode }: ComplianceLinksSectionProps) => {
  const country = countryCode === 'GB' ? 'UK' : 'US'
  const complianceWebappBaseUrl = getComplianceWebappBaseUrl()
  const documentsUrl = `${complianceWebappBaseUrl}/o/internal/admin/compliance/${country}/${workerId}`

  return (
    <RecordSection title="Compliance">
      <div style={containerStyle}>
        {complianceLink && (
          <div style={linkStyle}>
            <a href={complianceLink} target="_blank" rel="noopener noreferrer">
              View profile in compliance
            </a>
          </div>
        )}
        <div>
          <a href={documentsUrl} target="_blank" rel="noopener noreferrer">
            View documents in compliance
          </a>
        </div>
      </div>
    </RecordSection>
  )
}

export default ComplianceLinksSection
